import React from 'react';
import ReactDOM from 'react-dom/client';
import 'index.css';
import App from 'App';
import reportWebVitals from 'reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
async function start() {
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_ANALYTICS_MSW !== 'false') {
    const { worker } = await import('./mocks/browser');
    await worker.start({onUnhandledRequest:'bypass', quiet:true});
  }
  root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
  );
}
start().catch(() => {
  root.render(<p role="alert">분석 개발용 모킹을 시작하지 못했습니다. 새로고침해 주세요.</p>);
});

reportWebVitals();
